<template>
<!--  <div class="columns is-multiline" style="max-height:calc(100vh - 80px)">-->
  <div class="columns is-multiline">
    <div class="column is-8">
      <div class="flex-align">
        <div class="btn-add-category unselect" @click="addCategory">+ 새 카테고리 추가하기</div>
        <div class="btn-add-category unselect" v-if="saveState" @click="saveCats">카테고리 구성 저장하기</div>
      </div>
      <Finder v-if="vTree"
              ref="finder"
              :tree="tree"
              :theme="theme"
              @move="onMove"
              @expand="onExpand"
              :hasDragHandle="true"
              :dragEnabled="true"></Finder>
    </div>
    <div class="column is-4" v-if="selectedCategory">
      <div class="box" style="margin-right:20px;min-width:200px">
        <modal-category-detail
          isSpace
          @delete="removeCategory"
          @saved="refresh"
          :data.sync="selectedCategory"></modal-category-detail>
      </div>
    </div>
  </div>
</template>

<script>
  import {Finder} from "@jledentu/vue-finder";
  import ModalCategoryDetail from "../../module/modal/ModalCategoryDetail";

  export default {
    name: "CategoryReg",
    components: {
      ModalCategoryDetail,
      Finder
    },
    beforeDestroy() {
      if(this.saveState){
        this.saveCats();
      }
    },
    created() {
      this.getData();
    },
    data() {
      return {
        vTree: false,
        saveState: false,
        tree: {
          id: "root",
          children: []
        },
        movedCategoryId: undefined,
        theme: {
          primaryColor: "#272a2f",
          arrowColor: "#bbb",
          separatorColor: "#eee",
          separatorWidth: "1px",
          dropZoneBgColor: "rgba(255, 87, 34, 0.2)",
          draggedItemBgColor: "rgba(255, 87, 34, 0.5)"
        },
        newId: 9999,
        selectedCategory: undefined
      }
    },
    methods: {
      saveCats() {
        this.$store.commit('setLoading', true);
        this.$axios.post(this.getUrl('space/category'), {
          categories: this.tree.children,
          movedCategoryId: this.movedCategoryId
        }).then(() => {
          this.toast('카테고리 구성이 저장되었습니다.');
          this.saveState = false;
          this.refresh();
          this.$store.commit('setLoading', false);
        }).catch((e) => {
          this.toast('저장에 실패했습니다.');
          this.refresh();
          this.$store.commit('setLoading', false);
        });
      },
      async refresh() {
        await this.getData();
        this.vTree = false;
        setTimeout(() => {
          this.vTree = true;
          this.$nextTick(()=>{
            if(this.selectedCategory && this.selectedCategory.parent) {
              // console.log(this.selectedCategory.parent)
              this.$refs.finder.expand(this.selectedCategory.parent);
              this.selectedCategory = undefined;
            }
          });
        }, 100);
      },
      async getData() {
        await this.$axios.get(this.getUrl('space/category')).then(res => {
          this.tree.children = [];
          this.tree.children = res.data.map(cat1 => {
            let cat2 = [];
            if (cat1.child && cat1.child.length > 0) {
              cat2 = cat1.child.map(child => {
                let cat3 = [];
                if (child.child && child.child.length > 0) {
                  cat3 = child.child.map(grandchild => {
                    return this.setCategoryItem(grandchild);
                  });
                }

                return Object.assign(this.setCategoryItem(child), {children: cat3});
              });
            }
            return Object.assign(this.setCategoryItem(cat1), {children: cat2});
          });
          this.vTree = true;
        });
      },
      setCategoryItem(item) {
        let res = {
          id: item.id,
          label: item.name
        }
        Object.keys(item).forEach(key => {
          if (['id', 'child', 'parent_id', 'index'].indexOf(key) === -1) {
            res[key] = item[key];
          }
        });
        return res;
      },
      onExpand({expanded, sourceEvent}) {
        if (sourceEvent === 'click' || sourceEvent === 'drop') {
          let obj = {depth: 0};
          this.getCatDepth(obj, 1, this.$refs.finder.treeModel.visibleTree.children, expanded[expanded.length - 1]);
          this.selectedCategory = obj.cat;
        }
      },
      onMove({moved, to, index}) {
        this.movedCategoryId = moved;
        let obj = {depth: 0};
        this.getCatDepth(obj, 1, this.$refs.finder.treeModel.visibleTree.children, to);
        if (obj.depth > 2) {
          this.toast('카테고리는 3차까지만 구성해주세요.');
        }
        this.tree.children = this.$refs.finder.treeModel.visibleTree.children;
        this.saveState = true;
        this.saveCats();

      },
      getCatDepth(obj, depth, list, id) {
        for (let cat of list) {
          if (id === cat.id) {
            obj.depth = depth;
            obj.cat = cat;
            break;
          }
          else if (cat.children && cat.children.length > 0) {
            this.getCatDepth(obj, depth + 1, cat.children, id);
          }
        }
      },
      addCategory() {
        this.$axios.post(this.getUrl('space/category/append')).then((res) => {
          let data = res.data;
          data.children = [];
          this.tree.children.push(data);
          this.refresh();
        }).catch(error => {
          if (error.response) {
            this.toast(error.response.data.message);
          }
        });
      },
      duplicate(obj, dest) {
        Object.keys(dest).forEach(key=>{
          if(key!=='children') {
            obj[key] = dest[key];
          }
        });
      },
      saveCategory() {
        let obj = {};
        this.getCatDepth(obj, 1, this.tree.children, this.selectedCategory.id);
        this.duplicate(obj.cat, this.selectedCategory);

        /*for(let i=0; i<this.tree.children.length; i++) {
          let cat1 = this.tree.children[i];
          if(cat1.id === this.selectedCategory.id) {
            this.tree.children[i] = this.selectedCategory;
            this.duplicate(this.tree.children[i],)
            break;
          } else if(cat1.children) {
            for(let j=0; j<cat1.children.length; j++) {
              let cat2 = cat1.children[j];
              if(cat2.id === this.selectedCategory.id) {
                cat1.children[j] = this.selectedCategory;
                break;
              } else if(cat2.children) {
                for(let k=0; k<cat2.children.length; k++) {
                  let cat3 = cat2.children[k];
                  if(cat3.id === this.selectedCategory.id) {
                    cat3.children[k] = this.selectedCategory;
                    break;
                  }
                }
              }
            }
          }
        }*/

        this.refresh();
      },
      removeCategory() {
        for (let i = 0; i < this.tree.children.length; i++) {
          let item = this.tree.children[i];
          if (this.selectedCategory.id === item.id) {
            removeIndex(this.tree.children, i);
            break;
          } else if (item.children) {
            for (let j = 0; j < item.children.length; j++) {
              let item2 = item.children[j];
              if (this.selectedCategory.id === item2.id) {
                removeIndex(item.children, j);
                break;
              } else if (item2.children) {
                for (let k = 0; k < item2.children.length; k++) {
                  let item3 = item2.children[k];
                  if (this.selectedCategory.id === item3.id) {
                    removeIndex(item2.children, k);
                    break;
                  }
                }
              }
            }
          }
        }
        this.refresh();
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .btn-add-category
    padding 4px
    text-align center
    border 1px solid #ff5722
    color #ff5722
    border-radius 4px
    font-size 0.9rem
    width 150px
    margin 0 0 12px 8px

  .btn-add-category:hover
    color white
    background-color #ff5722
</style>

<style lang="stylus">
  @import "@jledentu/vue-finder/dist/vue-finder.css";
  .item .drag-handle
    padding 0 !important

  .tree-container .list-container
    margin-left 8px

  .list
    min-width 200px !important
    max-height calc(100vh - 500px)

  .item .inner-item
    padding 6px 10px !important

</style>
